import { queryOptions, UseQueryOptions } from "@tanstack/react-query";
import { BuildStates } from "~/constants/BuildStates";
import { Build } from "~/components/build/Show/lib/types";
import fetcher from "~/components/build/Show/lib/fetcher";

type BranchBuild = {
  url: string;
  number: number;
  state: BuildStates;
  blockedState: string;
};

export type NavigationData = {
  prevBranchBuild?: BranchBuild;
  nextBranchBuild?: BranchBuild;
  latestBranchBuild?: BranchBuild;
};

export const navigationQueryKey = (buildId: Build["id"]) => {
  return ["build", buildId, "navigation"];
};

export const navigationQueryOptions = (
  build: Build,
  queryOptionsArgs: Omit<UseQueryOptions<NavigationData>, "queryKey" | "queryFn"> = {},
) => {
  return queryOptions({
    queryKey: navigationQueryKey(build.id),
    queryFn: ({ signal }) => fetchNavigation(build.path, signal),
    ...queryOptionsArgs,
  });
};

function fetchNavigation(buildPath: Build["path"], signal: AbortSignal): Promise<NavigationData> {
  const url = new URL(`${buildPath}/navigation`, window.location.origin);

  return fetcher<NavigationData>(url, true, { signal });
}
